<app-form-area
  hiddenButtons
>
  <app-select
    label="{{ 'ADDRESSES_FORM.TYPE.TITLE' | translate }}"
    placeholder="{{ 'ADDRESSES_FORM.TYPE.PLACEHOLDER' | translate }}"
    [control]="control().get('addressType')"
    [items]="addressTypeOptions"
  />
  <app-input
    type="text"
    [label]="'ADDRESSES_FORM.CEP' | translate"
    [placeholder]="'ADDRESSES_FORM.CEP_PLACEHOLDER' | translate"
    [control]="control().get('zipCode')"
    (change)="getAddressByPostalCode()"
    mask="postalCode"
  />
  <app-select
    type="text"
    [label]="'ADDRESSES_FORM.STATE' | translate"
    [placeholder]="'ADDRESSES_FORM.STATE_PLACEHOLDER' | translate"
    [control]="control().get('state')"
    [items]="stateEnumOptions"
    search
  />
  <app-input
    type="text"
    [label]="'ADDRESSES_FORM.CITY' | translate"
    [placeholder]="'ADDRESSES_FORM.CITY_PLACEHOLDER' | translate"
    [control]="control().get('city')"
  />
  <app-input
    type="text"
    [label]="'ADDRESSES_FORM.PUBLIC_PLACE' | translate"
    [placeholder]="'ADDRESSES_FORM.PUBLIC_PLACE_PLACEHOLDER' | translate"
    [control]="control().get('street')"
  />
  <app-input
    type="text"
    [label]="'ADDRESSES_FORM.NEIGHBORHOOD' | translate"
    [placeholder]="'ADDRESSES_FORM.NEIGHBORHOOD_PLACEHOLDER' | translate"
    [control]="control().get('neighborhood')"
  />
  <app-input
    type="text"
    [label]="'ADDRESSES_FORM.NUMBER' | translate"
    [placeholder]="'ADDRESSES_FORM.NUMBER_PLACEHOLDER' | translate"
    [control]="control().get('number')"
  />
  <app-input
    type="text"
    [label]="'ADDRESSES_FORM.COMPLEMENT' | translate"
    [placeholder]="'ADDRESSES_FORM.COMPLEMENT_PLACEHOLDER' | translate"
    [control]="control().get('complement')"
  />
</app-form-area>
